// Utility to get environment variables from build-time process.env
export const getEnv = (key: string, fallback?: string): string => {
  // Get from process.env (build-time environment variables)
  if (process.env[key]) {
    return process.env[key] as string;
  }

  // Return fallback or empty string
  return fallback || '';
};